import React from "react";
import "./Newlaunch.scss";
import penawaran from "../../../src/Media/Hardsell_Eastern.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const Penawaran = () => {
  const Cherrywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285136087667&text=Halo%20Alex,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Eastern%20(Promo)%20https://marketinggrandeastern.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div id="promo" className="promocgb">
      <div className="promo-cgb">
        <div className="gambarpromo">
          <img src={penawaran} alt={penawaran} />
        </div>
        <div className="ket-promo">
          <div className="judul">
            <h1> Promo Keseluruhan Grand Eastern</h1>
          </div>
          <div className="promolist">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>&nbsp;&nbsp;Free DP</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>&nbsp;&nbsp;Free PPN</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>&nbsp;&nbsp;Free BPHTB</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>&nbsp;&nbsp;Free AJB</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>&nbsp;&nbsp;Free BBN</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>
                &nbsp;&nbsp;Subsidi Biaya KPR
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>
                &nbsp;&nbsp;Free Smartdoor Lock
              </span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "#626570"}}>
                &nbsp;&nbsp;Cicilan Start 5 Juta/Bulan
              </span>
            </div>
          </div>
          <button className="buttonpenawaran" onClick={Cherrywa}>
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
